import React, {useState,useContext} from 'react';

import {Link} from 'react-router-dom';

import '../../index.css';
import {MyContext} from '../login/MyContext';




function Menu(props) {

    const {user, logout} = useContext(MyContext);

  const [dropdown, setDropdown]=useState(false);

  const abrirCerrarDropdown=()=>{
    setDropdown(!dropdown);
  }
    
  return (
<>
    <div id="sidebar" className="app-sidebar">

    <div className="app-sidebar-content" data-scrollbar="true" data-height="100%">
    
    <div className="menu">
    <div className="menu-profile">
    <a href="javascript:;" className="menu-profile-link" data-toggle="app-sidebar-profile" data-target="#appSidebarProfileMenu">
    <div className="menu-profile-cover with-shadow"></div>
    <center><div className="menu-profile-image">
    <img src="../assets/img/user/user-13.jpg" alt="" />
    </div></center>
    <div className="menu-profile-info">
    <div className="d-flex align-items-center">
    <div className="flex-grow-1">
    <a href="#"  style={{textDecoration:"none", color:"white"}}>{user.name}</a>
    </div>
    <div className="menu-caret ms-auto"></div>
    </div>
    
    </div>
    </a>
    </div>
    {/*<div id="appSidebarProfileMenu" className="collapse">
    <div className="menu-item pt-5px">
    <a href="javascript:;" className="menu-link">
    <div className="menu-icon"><i className="fa fa-cog"></i></div>
    <div className="menu-text">Settings</div>
    </a>
    </div>
    <div className="menu-item">
    <a href="javascript:;" className="menu-link">
    <div className="menu-icon"><i className="fa fa-pencil-alt"></i></div>
    <div className="menu-text"> Send Feedback</div>
    </a>
    </div>
    <div className="menu-item pb-5px">
    <a href="javascript:;" className="menu-link" >
    <div className="menu-icon"><i className="fa fa-question-circle"></i></div>
    <div className="menu-text"> Cerrar Sesión</div>
    </a>
    </div>
    <div className="menu-divider m-0"></div>
  </div> */ }
    <div className="menu-header"><center><img src="https://assets.stickpng.com/images/580b57fcd9996e24bc43c51f.png" width="100px" /></center>
    </div>
  
    
  
    {console.log( global.id=user.id)}

    <div class="menu-item has-sub active">
<a href="javascript:;" class="menu-link">
<div class="menu-icon">
<i class="fab fa-google" style={{color:'#fbbc04'}}></i>
</div>
<div class="menu-text">Nivel Google Adsense </div>
<div class="menu-caret"></div>
</a>
<div class="menu-submenu">
<div class="menu-item active">
<Link to="/Principal" className="menu-link">
<div class="menu-text"> <i class="fas fa-money-check-alt" style={{color:"#B2B2B2"}}></i>&nbsp;&nbsp;Monetización</div>
</Link>
</div>
<div class="menu-item active">
<Link to="/Anuncios" className="menu-link">
<div class="menu-text"> <i class="fas fa-ad" style={{color:"#B2B2B2"}}></i> &nbsp;Anuncios</div>
</Link>
</div>


<div class="menu-item active">
<Link to="/Sitios" className="menu-link">
<div class="menu-text"> <i class="fas fa-window-restore"></i> &nbsp;Sitios</div>
</Link>
</div>

<div class="menu-item active">
<Link to="/Pagos" className="menu-link">
<div class="menu-text"> <i class="fas fa-money-bill-alt" style={{color:"#B2B2B2"}}></i> &nbsp;Pagos</div>
</Link>
</div>



</div>
</div>
        
   
      





    <div class="menu-item has-sub active">
<a href="javascript:;" class="menu-link">
<div class="menu-icon">
<i class="fab fa-google" style={{color:'#fbbc04'}}></i>
</div>
<div class="menu-text">Nivel Ad-Manager adx</div>
<div class="menu-caret"></div>
</a>
<div class="menu-submenu">
<div class="menu-item active">
<Link to="#" className="menu-link">
<div class="menu-text"> <i class="fas fa-mail-bulk" style={{color:"red"}}></i>&nbsp;Mensajería</div>
</Link>
</div>
<div class="menu-item active">
<Link to="#" className="menu-link">
<div class="menu-text"> <i class="fas fa-copyright" style={{color:"red"}}></i> &nbsp;Seguridad de la marca</div>
</Link>
</div>

<div class="menu-item active">
<Link to="#" className="menu-link">
<div class="menu-text"> <i class="fas fa-folder-tree" style={{color:"red"}}></i> &nbsp;Informes</div>
</Link>
</div>

<div class="menu-item active">
<Link to="#" className="menu-link">
<div class="menu-text"> <i class="fas fa-vote-yea" style={{color:"red"}}></i> &nbsp;Optimización</div>
</Link>
</div>

<div class="menu-item active">
<Link to="#" className="menu-link">
<div class="menu-text"> <i class="fas fa-users" style={{color:"red"}}></i> &nbsp;MultiCuenta</div>
</Link>
</div>

</div>
</div>
        
   

   
       
    
    
    
    <div className="menu-item d-flex">
    <a href="javascript:;" className="app-sidebar-minify-btn ms-auto" data-toggle="app-sidebar-minify"><i className="fa fa-angle-double-left"></i></a>
    </div>
    
    </div>
    </div>
    </div>

<div className="app-sidebar-bg"></div>
<div className="app-sidebar-mobile-backdrop"><a href="#" data-dismiss="app-sidebar-mobile" className="stretched-link"></a></div>

</>

  
       
    )

    
  }

 


export default Menu